import { AxiosInstance } from 'axios';
import { getExportConfig, handleFileExport } from '../../../../../../helpers/fileExport';
import { PRE_PAYMENT_REPORT_ENDPOINT } from '../endpoint';
import { PrePaymentReportRequestModel } from '../models/PrePaymentReportRequestModel';

export const exportPDF =
  (axios: AxiosInstance) =>
  async (params?: PrePaymentReportRequestModel): Promise<void> => {
    return await axios
      .get(`${PRE_PAYMENT_REPORT_ENDPOINT}`, {
        params: { ...params },
        ...getExportConfig(params),
      })
      .then(response => {
        handleFileExport(response, {
          file_type: params?.file_type,
          filename: 'prepayment-arrival-report',
        });
      });
  };
